import styled from 'styled-components';

import { BoxShadow, Breakpoint, Color, ZIndex } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { Button } from '../button/button.component';
import { Logo } from '../logo/logo.component';

import { ContainerProps } from './fullscreenPopup.types';

export const Container: StyledComponent<'div', ContainerProps> = styled.div<ContainerProps>`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: ${ZIndex.FullscreenPopup};
  opacity: ${({ $isVisible }: ContainerProps): string => $isVisible ? '1' : '0'};
  pointer-events: ${({ $isVisible }: ContainerProps): string => $isVisible ? 'initial' : 'none'};
  transition: 0.3s;
  overflow-y: auto;
  background-color: ${Color.White};
`;

export const InnerContainer: StyledComponent<'div'> = styled.div`
  margin-top: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media ${Breakpoint.Mobile} {
    width: calc(100% - 40px);
    margin: 60px auto 0;
  }
`;

export const Content: StyledComponent<'div'> = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ButtonsContainer: StyledComponent<'div'> = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 480px;
  width: 100%;
  padding-bottom: 20px;
`;

export const StyledButton: StyledComponent<typeof Button> = styled(Button)`
  & + & {
    margin-top: 24px;
  }
`;

export const LogoSection: StyledComponent<'div'> = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  box-shadow: ${BoxShadow.BackgroundShadow};
`;

export const StyledLogo: StyledComponent<typeof Logo> = styled(Logo)`
  width: 98px;
`;
